import { api } from "../../services/Api.js";

export function get_albums({ commit, state }, payload ){
      
    // adding token
    payload.token=state.appSettings.token

    

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
      
    // return chainable promise
    return api
      .post(school,"get_albums.php",payload)
      .then( result =>{ 
        
        commit('SET_ALBUMS', {store_key:payload.store_key, albums:result.data});
       
      })
      .catch( () => {
        //console.log("ERROR GETTING ALBUMS",error);
       
      })

      
  }